module.exports = __webpack_public_path__ + "static/media/hr.d01a1866.svg";